<template>
    <div class="p-datatable p-component">
        <div class="p-datatable-wrapper" v-if="listPermissions && listPermissions.length">
            <div class="row-item-header">
                <div style="width: 40%;"> <span class="p-column-title">Module</span></div>
                <div style="width: 50%;"><span class="p-column-title">Tính năng</span></div>
                <div class="txt-center" style="width: 10%;"><span class="p-column-title">Phân quyền</span></div>
            </div>
            <div class="row-body" :key="index" v-for="(item, index) in listPermissions">
                <div v-if="item.permissions && item.permissions != undefined && item.permissions != null">
                    <div class="row-item" :key="index1" v-for="(item1, index1) in item.permissions">
                        <div class="item" style="width: 40%;" v-if="index1 > 0" ></div>
                        <div class="item" style="width: 40%;" v-else > <span class="p-column-title">{{ item.name }}</span></div>
                        <div class="item" style="width: 50%;"> <span class="p-column-title">{{ item1.name }}</span></div>
                        <div class="item txt-center" style="width: 10%;">
                            <Checkbox v-if="type == 'web'" :key="item1.id" :binary="true" @change="checkedChange" v-model="listChecked[item1.id]"  :value="item1.id" :name="'checkbox_' + item1.id" />
                            <Checkbox v-else-if="type == 'mobile'" :disabled="true" :key="item1.id" :binary="true"  v-model="checked_mobile"   />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-datatable-wrapper" v-else>
            <div class="row-item-header">
                <div style="width: 40%;"> <span class="p-column-title">Module</span></div>
                <div style="width: 50%;"><span class="p-column-title">Tính năng</span></div>
                <div class="txt-center" style="width: 10%;"><span class="p-column-title">Phân quyền</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import DataServices from '@/core/DataServices'
export default {
    props: {
        type: {
            type: String,
            default: 'web'
        },
        permissions: Array
    },
    data() {
        return {
            listPermissions: [],
            listChecked: this.permissions,
            checked: false,
            modelName: 'group_permission',
            checked_mobile:true,//default check mobile
        }
    },
    async mounted () {
        await this.getPermission();
    },
    methods: {
        checkedChange() {
            this.$emit('change', {type: this.type, lists: this.listChecked});
        },
        async getPermission() {
            var variables = {
                where_key: {
                    type: {'_eq': this.type },
                    status: {'_eq': 1}
                },
                orderBy: {
                    ordering: 'asc'
                }
            }
            var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": "id name ordering permissions(where: {status: {_eq: 1}, type: {_eq: \"" + this.type + "\" } }, order_by: {ordering: asc}) { id name ordering }"});
            this.listPermissions = data[Object.keys(data)];
        }
    },
}
</script>

<style lang="scss" scoped>

</style>